import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { myCompanyTeams } from './types';

import { requestMyCompanyTeamsSuccess, requestMyCompanyTeamsFailure } from './actions';

const logger = new Logger('Saga:Team:MyCompanyTeams');

export function* requestMyCompanyTeamsReducer() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(authApiService.get, routerService.generate('api.teams.my_teams'));

    yield put(requestMyCompanyTeamsSuccess(response.data));
  } catch (error) {
    logger.error(
      'Failed to fetch all teams on the current user company with the following error',
      error,
    );
    yield put(requestMyCompanyTeamsFailure(error));
  }
}

export default function* myCompanyTeamsSaga() {
  return yield all([takeLatest(myCompanyTeams.request, requestMyCompanyTeamsReducer)]);
}
